import { handleMessages } from 'poly-eshop4/eshop/ui/js/util';

const handlePositionDateChange = (event, del = false) => {
  let $form;
  if (del) {
    $form = $(event.currentTarget).siblings('[data-position-date]');
    $form.find('input[name="date"]').val('');
  } else {
    $form = $(event.target).closest('form');
  }
  const $deleteBtn = $form.siblings('[data-container-position-date-delete]');
  const formData = $form.serializeArray();
  const year = new Date().getFullYear() - 1;
  if (formData[1].value === '' || formData[1].value.split('-') > year.toString()) {
    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      data: $form.serializeArray(),
      success: (resp) => {
        // At the moment no msg
        $(event.target).val(resp.date);
        if (resp.date) {
          $deleteBtn.removeClass('hide');
        } else {
          $deleteBtn.addClass('hide');
        }
        handleMessages(resp);
      },
      error: (resp) => {
        // At the moment calorder does not validate the date (validation will take place in create order)
        handleMessages(resp);
      },
    });
  }
};

// eslint-disable-next-line no-restricted-globals
$('[data-position-date]').on('change', () => handlePositionDateChange(event));

// eslint-disable-next-line no-restricted-globals
$('[data-container-position-date-delete]').on('click', () => handlePositionDateChange(event, true));
